export default __webpack_public_path__ + "static/media/ic_download.93ec7008.svg";